//import Moment from "moment";

const getCount = (state) => {
	return state.pedidos.length;
}

const ultimaAtualizacaoListaPedido = (state) => {
	if (state.ultimaAtualizacaoListaPedido == null) {
		return true;
	}
	else if(!state.pedidos)
	{
		return true;
	}
	else {
		const d = new Date();
		let hour = d.getHours();
		return (
			state.pedidos.length == 0 ||
			hour - state.ultimaAtualizacaoListaPedido.getHours() > 0
		);
	}
}
const ultimaAtualizacaoListaPedidosNF = (state) => {
	if (state.ultimaAtualizacaoListaPedidosNF == null) {
		return true;
	}
	else if(!state.pedidosEntrada)
	{
		return true;
	}
	else {
		const d = new Date();
		let hour = d.getHours();
		return (
			state.pedidosEntrada.length == 0 ||
			hour - state.ultimaAtualizacaoListaPedidosNF.getHours() > 0
		);
	}
}

export default {
	getCount,
	ultimaAtualizacaoListaPedido,
	ultimaAtualizacaoListaPedidosNF
}